module.exports = __webpack_public_path__ + "img/fraction3-1.a9262491.svg";